import { PageState } from 'models/PageState';
import { isProductPage } from 'models/ProductPageModel';

export const getVideoId = ({ currentPage }: PageState) =>
  isProductPage(currentPage) ? currentPage.video.id : '';

export const getVideoTitle = ({ currentPage }: PageState) =>
  isProductPage(currentPage) ? currentPage.video.title : '';
